import(/* webpackMode: "eager", webpackExports: ["Background"] */ "/vercel/path0/frontend/src/app/components/Background/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorPageContainer"] */ "/vercel/path0/frontend/src/app/sdc/components/ErrorPage/styles.ts");
